export default [
  { name: 'Guidelines', title: 'Guidelines', hitComponent: 'PageHit' },
];
